module.exports = __webpack_public_path__ + "img/PLANETE_OUI_120X35.51e421ab.png";